<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="col-md-12" style="margin-top: 24px" />

      <h4 class="text-center">Data subscriptions</h4>
      <div class="col-md-12" style="margin-top: 24px" />
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="DataSubscription__table p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th :class="commonTableHeadClass()">Name</th>
              <th :class="commonTableHeadClass('ps-2')">Expiration</th>
              <th :class="commonTableHeadClass('ps-2')">Lookback Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in getUserData.subscriptions.filter(
                (x) => x.isFree === false
              )"
              v-bind:key="item"
            >
              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ item.name }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">{{ item.endDate }}</h6>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex px-2">
                  <div class="my-auto">
                    <h6 class="mb-0 text-sm">
                      {{
                        item.lookbackWindow ? item.lookbackWindow : "unlimited"
                      }}
                    </h6>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.DataSubscription__table {
  max-height: 270px;
  overflow-x: v-bind("tableOverflowX");
  -webkit-overflow-scrolling: touch;
}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "projects-table",
  computed: {
    ...mapGetters(["getUserData"]),
    tableOverflowX() {
      return this.getUserData.subscriptions.filter((x) => x.isFree === false)
        .length === 0
        ? "clip"
        : "auto";
    },
  },
  methods: {
    commonTableHeadClass(classes) {
      return `text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ${classes}`;
    },
  },
};
</script>
